import React from 'react';

const Tooltip = ({ tip, onHover, children, className = '' }) => {
  if (children) {
    return (
      <div className={['tooltip', className].filter(Boolean).join(' ')} onMouseEnter={onHover}>
        {children}
        <div className="tooltiptext">
          {tip}
        </div>
      </div>
    );
  }

  return (
    <div className="tooltiptext">
      {tip}
    </div>
  );
};

export default Tooltip;
